// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__wJ_k6","hero__content":"styles_hero__content__5DO78","hero__img":"styles_hero__img__kFqFY"};